// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"CookieConsentFloatingButton_floatingButton__CKRuh"};